import React from 'react'
import { Icon } from 'antd'
import moment from 'moment'
import * as styles from './index.scss'

interface Props {
  id: number
  cover: string
  time: number
  name: string
  region: string
  depart: string
  intro: string
  desc: string
  color: { r: number; g: number; b: number }
  block: boolean
  broken: boolean
  one: boolean
  onClick: React.EventHandler<any>
}

const FourStar: React.SFC<Props> = ({
  id,
  cover,
  time,
  name,
  region,
  depart,
  intro,
  desc,
  color,
  block,
  broken,
  one,
  onClick,
}) => {
  const cls = (t, s = '') => (one ? `${t}one${s}` : `${t}for${s}`)
  const BreakItem = () => (
    <div
      className={styles[cls('break')]}
      style={{ borderColor: `rgb(${color.r}, ${color.g}, ${color.b})` }}
    >
      <div
        className={styles[cls('break', 'Unknown')]}
        style={{
          color: `rgb(${color.r}, ${color.g}, ${color.b})`,
          backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, 0.3)`,
          boxShadow: `0 8px 12px 0 rgba(${color.r}, ${color.g}, ${
            color.b
          }, 0.3)`,
          borderColor: `rgb(${color.r}, ${color.g}, ${color.b})`,
        }}
      >
        ?
      </div>
      <div
        style={{
          backgroundColor: `rgb(${color.r}, ${color.g}, ${color.b})`,
          boxShadow: `0 4px 10px 0 rgba(${color.r}, ${color.g}, ${
            color.b
          }, 0.3)`,
        }}
        className={styles[cls('break', 'Tips')]}
      >
        下一个会是你吗？
      </div>
    </div>
  )
  return broken ? (
    <BreakItem />
  ) : (
    <div
      className={styles[cls('star')]}
      style={{
        borderColor: `rgb(${color.r}, ${color.g}, ${color.b})`,
        cursor: id ? 'pointer' : 'no-drop',
      }}
      onClick={id && onClick}
    >
      <div className={styles[cls('star', 'Cover')]}>
        <div
          style={{
            backgroundImage: `url(${cover})`,
            backgroundPosition: 'top center',
            backgroundSize: '100%',
            height: 232,
          }}
        />
      </div>
      <div
        className={styles[cls('star', 'Inner')]}
        style={{
          backgroundColor: block && `rgb(${color.r}, ${color.g}, ${color.b})`,
        }}
      >
        <div className={styles[cls('star', 'Top')]}>
          <div
            className={styles[cls('star', 'TopName')]}
            style={{
              color: block && '#fff',
            }}
          >
            <span>{`${name}`.trim()}</span>
          </div>
          <div
            className={styles[cls('star', 'TopDesc')]}
            style={{
              color: block && '#fff',
            }}
          >
            <span>{`${region}`.trim()}</span>
            <span>{depart}</span>
            <span>{moment(time * 1000).format('YYYY-MM-DD')}</span>
          </div>
        </div>
        {!one &&
          intro && (
            <div
              className={styles[cls('star', 'Desc')]}
              title={desc}
              style={{
                color: block && '#fff',
              }}
            >
              <div
                className={styles[cls('star', 'DescTitle')]}
                style={{
                  color: block && '#fff',
                }}
              >
                介绍：
              </div>
              <div className={styles[cls('star', 'DescIntro')]} title={intro}>
                {intro}
              </div>
            </div>
          )}
        <div
          className={styles[cls('star', 'Desc')]}
          title={desc}
          style={{
            color: block && '#fff',
          }}
        >
          <div
            className={styles[cls('star', 'DescTitle')]}
            style={{
              color: block && '#fff',
            }}
          >
            宣言：
          </div>
          <div className={styles[cls('star', 'DescContent')]} title={desc}>
            {desc || '-'}
          </div>
        </div>
        <div
          className={styles[cls('star', 'Bottom')]}
          style={{
            opacity: !id && 0.5,
          }}
        >
          成长故事
          <Icon type="right" />
        </div>
      </div>
    </div>
  )
}

export default FourStar
